import React from 'react'
import { Outlet, createFileRoute } from '@tanstack/react-router'
import RouteGuard from '@/components/auth/RouteGuard'
import PublicAppHeader from '@/layout/PublicAppHeader'

function LandingLayoutShell() {
  return (
    <RouteGuard requireAuth={false}>
      <div className="flex-1 transition-all duration-300 ease-in-out">
        <PublicAppHeader />
        <div className="p-4 mx-auto max-w-(--breakpoint-2xl) md:p-6">
          <Outlet />
        </div>
      </div>
    </RouteGuard>
  )
}

export const Route = createFileRoute('/(public)/landing')({
  component: LandingLayoutShell,
})

